export interface ChangePassword {
  password: string;
  email?: string;
  password_new: string;
  password_confirm: string;
}
